import { FieldValues, useForm } from '@pankod/refine-react-hook-form';
import { Helmet } from 'react-helmet';
import FormStudent from 'components/common/FormStudent';

const CreateStudent = () => {
  const { refineCore: { onFinish, formLoading }, register, watch, handleSubmit } = useForm();
  
  const onFinishHandler = async (data: FieldValues) => {
    
    await onFinish(data)
  };

  return (
    <div>
      <Helmet>
        <title>Edit Student Details</title>
      </Helmet>
      <FormStudent 
      type="Edit"
      register={register}
      watch={watch}
      onFinish={onFinish}
      formLoading={formLoading}
      handleSubmit={handleSubmit}
      onFinishHandler={onFinishHandler}
    />
    </div>
  )
}
export default CreateStudent;
